// extracted by mini-css-extract-plugin
export default {"container":"InvestigationSummary_container__tsZ55"};